import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SectionHeader } from '../components/ui/SectionHeader';
import { ChevronLeft } from 'lucide-react';

export const CopyrightNotice: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="py-12">
      <div className="container mx-auto px-6 max-w-4xl">
        <button 
            onClick={() => navigate(-1)}
            className="group flex items-center gap-2 mb-8 text-gray-300 hover:text-white transition-colors"
        >
            <ChevronLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            <span className="text-xs font-bold uppercase tracking-widest">Back</span>
        </button>
        
        <div className="bg-black/60 backdrop-blur-md border border-white/10 p-8 md:p-12">
            <SectionHeader subtitle="Legal" title="Copyright Notice" />

            <div className="prose prose-invert max-w-none prose-p:text-slate-300 prose-headings:text-white prose-a:text-astral-purple prose-strong:text-white">
                <p>Last updated: {new Date().toLocaleDateString()}</p>
                
                <h2>1. General Statement</h2>
                <p>
                    All content included on this site, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software, is the property of AstralVibe or its content suppliers and protected by international copyright laws. The compilation of all content on this site is the exclusive property of AstralVibe, with copyright authorship for this collection by AstralVibe, and protected by international copyright laws.
                </p>
                
                <h2>2. Music, Recordings, and Artist Materials</h2>
                <p>
                    All musical compositions, sound recordings, master recordings, artist names, likenesses, images, and biographical information featured on this website are the exclusive property of AstralVibe and/or its respective recording artists, composers, and publishers. This material is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, publicly perform, display, create derivative works from, or otherwise exploit any of the aforementioned materials without the express prior written consent of AstralVibe and the relevant rights holders.
                </p>

                <h2>3. Trademarks</h2>
                <p>
                    AstralVibe's trademarks and trade dress may not be used in connection with any product or service that is not AstralVibe's, in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits AstralVibe. All other trademarks not owned by AstralVibe or its subsidiaries that appear on this site are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by AstralVibe or its subsidiaries.
                </p>

                <h2>4. Notice and Procedure for Making Claims of Copyright Infringement</h2>
                <p>
                    If you believe that your work has been copied in a way that constitutes copyright infringement, please provide AstralVibe's copyright agent with the written information specified below. Please note that this procedure is exclusively for notifying AstralVibe that your copyrighted material has been infringed.
                </p>
                <ul>
                    <li>An electronic or physical signature of the person authorized to act on behalf of the owner of the copyright interest;</li>
                    <li>A description of the copyrighted work that you claim has been infringed upon;</li>
                    <li>A description of where the material that you claim is infringing is located on the site;</li>
                    <li>Your address, telephone number, and e-mail address;</li>
                    <li>A statement by you that you have a good-faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law;</li>
                    <li>A statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf.</li>
                </ul>
                <p>
                    AstralVibe's Copyright Agent for notice of claims of copyright infringement on its site can be reached as follows:<br/>
                    <strong>Email:</strong> <a href="mailto:copyright@astralvibe.art">copyright@astralvibe.art</a>
                </p>

                 <h2>5. Demo Submissions</h2>
                <p>
                    Please refer to our <Link to="/terms" className="text-astral-purple hover:underline">Terms and Conditions</Link> for information regarding the submission of demos and other unsolicited materials. Submitting material does not transfer any copyright ownership to AstralVibe.
                </p>
            </div>
        </div>
      </div>
    </div>
  );
};